<template>
	<v-dialog
		max-width="1200px"
    max-height="800px"
    persistent
    value="true"
    scrollable
	>
		<v-card>
			<v-toolbar
				dense
        flat
        color="primary"
        dark
			>
				Select a Field from {{ templateName }}
        <v-spacer/>
        <v-icon 
          fab
          flat
          dark
          @click="$emit('cancel')"
        >
          mdi-close
        </v-icon>
			</v-toolbar>
      <div
        v-if="loading"
        style="padding: 20px;text-align:center;font-size: 18px;color: rgba(0,0,0,0.15);"
      >
        Loading...
      </div>
      <div
        v-if="items.length == 0"
        style="padding: 20px;text-align:center;font-size: 18px;color: rgba(0,0,0,1);"
      >
        No Selectable Fields
      </div>
      <v-treeview
        v-if="!loading"
        activatable
        open-on-click
        :open.sync="open"    
        :items="items"
        style="overflow-y: scroll;"
      >
        <template style="display: inline-block;" v-slot:label="{ item }">
          <span 
            :title=item.name
            style="font-size:smaller;display: inline-block;max-width: 750px; white-space:nowrap;overflow: hidden; text-overflow: ellipsis;margin-top: 6px;"
          >
           {{ item.name }}
          </span>
          <v-btn 
            v-if="selected === null && item.children.length == 0" 
            small 
            dense
            style="float: right;"
            @click="selected = {qid: item.qid !== undefined ? item.qid : item.id , fid: item.fid }"
          >
            Select
          </v-btn>
          <div 
            v-if="selected !== null && selected.fid == item.fid"
            style="display: inline;float: inline-end;"
          >
            <v-btn
              small
              dense
              @click="selected = null"
            >
              Cancel
            </v-btn>
            <v-btn 
              small 
              dense
              color="primary"
              @click="$emit('select', {question_id: selected.qid, fieldtype_id: selected.fid})"
            >
              Confirm
            </v-btn>
          </div>
        </template>
      </v-treeview>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import FormTemplatePart from './formtemplate/FormTemplatePart.vue'

export default {
	name: 'FormTemplateFieldSelector',
	props: ['templateID', 'filter'],
  components: {
    FormTemplatePart
  },
  data () {
    return {
      root_parts: [],
      selected: null,
      items: [],
      open: [],
      templateName: "",
      loading: true
		}
  },
	created () {
    this.getTemplate(this.templateID)
    .then(response => {
      this.templateName = response.name
      this.root_parts = response.root_parts
      this.populateTree()
    })
	},
	methods: {
		...mapActions('formtemplate', [
			'getTemplate'
		]),
    populateTree () {
      for (let part of this.root_parts){
        if (!part.archived && part.part_type == 's' && part.parts.length > 0){ 
          this.items.push(this.getChildren(part)) 
        }
      }
      this.loading=false
    },
    getChildren (part) {
      if (part.part_type == 's'){
        const children = []
        const parts = part.parts
        if (parts.length > 0){
          for (let x of parts){
            if(x.part_type == 's' || x.part_type == 'q'){
              let child = this.getChildren(x)
              if (child !== undefined){
                children.push(this.getChildren(x))
              }
            }
          }
          if(this.filter !== undefined){
            if(children.length > 0){
              return {id: part.id, name: part.text, children: children}
            }
          }
          else{
            return {id: part.id, name: part.text, children: children}
          }
        }
      }
      if (!part.archived && part.part_type == 'q'){
        if (part.text.startsWith('<')){
          part.text = part.text.replace( /(<([^>]+)>)/ig, '')
        }
        if (part.fieldtype.subfieldtypes !== undefined && part.fieldtype.subfieldtypes.length > 0){
          let children = this.getSubFields(part.fieldtype.subfieldtypes, part.id)
          if(children.length > 0){
            return {id: part.id, name: part.text, children: children, fid: part.fieldtype.id}
          }
        }
        if(this.filter === undefined){
          return {id: part.id, name: part.text, children: [], fid: part.fieldtype.id}
        } else {
          if(this.filter == part.fieldtype.atomic_type_name){
            return {id: part.id, name: part.text, children: [], fid: part.fieldtype.id}
          }
        }
      }
    },
    getSubFields(subfieldtypes, qid){
      let children = []
      for (let subfield of subfieldtypes){
        if(this.filter !== undefined){
          if(subfield.atomic_type === this.filter){
            children.push({id: subfield.id, name: subfield.text, children: [], qid: qid, fid:subfield.id})
          }
        }
        else {
          children.push({id: subfield.id, name: subfield.text, children: [], qid: qid, fid:subfield.id})
        }
      }
      return children
    }
	}
}
</script>

<style scoped>
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

</style>